// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `chart-gauge-component{height:100%}`, "",{"version":3,"sources":["webpack://./src/shared/components/chart-gauge/chart-gauge.component.scss"],"names":[],"mappings":"AAAA,sBACI,WAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
